// extracted by mini-css-extract-plugin
export default {"cancel":"CancelLoanButton_cancel__I3AEm"};